import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { ColorWrapper, GridStyled, TextParagraph } from '@atoms'
import { Alert } from '@interco/inter-ui/components/Alert'
import { Button } from '@interco/inter-ui/components/Button'
import { useFeedbackPageTracking, useGoHomeButton, useTrackingRefin } from '@hooks'
import { Timer } from '@signals'
import { BridgeService } from '@services/bridge'
import { ApplicationState } from '@store/types'
import { Page } from '@templates'
import routes from '@routes/routes'
import { StepRefin } from '@utils/enums'
import { sendButtonClickTracking } from '@hooks/useFeedbackTracking'

import { Content } from './styles'

const INSSBloqueado = () => {
  const navigate = useNavigate()
  const isApp = useSelector((state: ApplicationState) => state.ui.navigation.isApp)

  useTrackingRefin(StepRefin.INSS_BLOQUEADO)
  useFeedbackPageTracking('Benefício INSS bloqueado', 'Benefício INSS bloqueado')
  const handleGoHome = useGoHomeButton('btn_voltar_home_beneficio_bloqueado')

  return (
    <Page
      showLeftIcon={false}
      stickyFooter={
        <>
          <Alert type="grayscale">
            Alguns benefícios são bloqueados por 90 dias. Caso tenha ultrapassado esse prazo,
            realize o desbloqueio.
          </Alert>
          <Button
            variant="primary"
            aria-label="Aprender a desbloquear"
            onClick={() => {
              BridgeService.tic({
                name: 'btn_aprender_desbloquear',
                action: 'aprender_desbloquear',
              })
              sendButtonClickTracking(isApp, 'Aprender a desbloquear', routes.BENEFICIO_BLOQUEADO)
              navigate(routes.BENEFICIO_BLOQUEADO)
            }}
          >
            Aprender a desbloquear
          </Button>
          <Button variant="secondary" aria-label="Ir para a home" onClick={handleGoHome}>
            Ir para a home
          </Button>
        </>
      }
    >
      <Content>
        <GridStyled justify="space-around" margin="40px 0 24px 0">
          <Timer aria-hidden="true" />
        </GridStyled>
        <ColorWrapper fontWeight="600" style={{ marginBottom: '8px', textAlign: 'center' }}>
          <TextParagraph variant="headline-h1" textAlign="center">
            Benefício bloqueado
          </TextParagraph>
        </ColorWrapper>
        <TextParagraph variant="body-3" textAlign="center">
          Para proteger e evitar fraudes, o <strong>INSS bloqueou o seu benefício.</strong>{' '}
          Desbloqueie no App do Meu INSS e retorne ao SuperApp do Inter para continuar a sua
          contratação.
        </TextParagraph>
      </Content>
    </Page>
  )
}

export default INSSBloqueado
